// extracted by mini-css-extract-plugin
export default {"reviewsHeader":"_f4do0p","reviewRemoved":"_15u1dtl"};